import { createNativeStackNavigator } from "@react-navigation/native-stack";
import MainScreen from "../screens/mainscreen";
import BranchScreen from "../screens/branchscreen";
import SensorScreen from "../screens/sensorscreen";
import { pageTitle } from "../context/helper";

const Stack = createNativeStackNavigator();

const SensorStack = () => {
  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      <Stack.Screen
        component={MainScreen}
        name="Main"
        options={{ title: pageTitle("Messdatenübersicht") }}
      />
      <Stack.Screen component={BranchScreen} name="Branch" 
        options={{ title: pageTitle("Standortübersicht") }}
        />
      <Stack.Screen component={SensorScreen} name="Sensor" 
        options={{ title: pageTitle("Sensormessdaten") }}
        />
    </Stack.Navigator>
  );
};

export default SensorStack;
